import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
  },
  state: {
    alignSelf: 'center',
    paddingLeft: theme.spacing(1),
    fontSize: '1rem',
    fontWeight: 'bold',
  },
}));

export default useStyles;
